<template>
  <div>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="notify.show = false"></my-notify-dialog>

  </div>
</template>
<script>




import MyNotifyDialog from "@/components/MyNotifyDialog.vue";

export default {
  name: "TestPage",
  components: {MyNotifyDialog},
  data() {
    return {
      notify: {title: "签到结果", show: true, success: false, msg: "签离区域错误,<br/>当前区域为localAreaName，<br/>请到applyAreaName签离",},

      success: true,
      input: "",
    }
  },

  mounted() {

  },
  destroyed() {
  },

  methods: {
    onClick() {

    },
  }
}
</script>

<style scoped lang="less">


</style>
